import getCdiData from './getCdiData'
import getVinculos from './getVinculos'
import getMatches from './getMatches';

export const getCdiDataService = getCdiData;
export const getVinculosService = getVinculos;
export const getMatchesService = getMatches;